const ROLE = 'finder:field:promocode';

export { ROLE };
